// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 239) return "static/chunks/239-71fd76a9d1e8b14f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "e9612c2b54b81f2c" + ".js";
};